// Comment threads on workbook cells. Threads belong to the pay period: every
// run of the period lists them, each placed on the cell it points at in that
// run. See the api's Spreadsheet::CommentThreadPlacer.

export const CELL_COMMENT_PLACEMENT = {
  // Followed its cell by content — may have moved rows since it was written.
  anchored: "anchored",
  // The cell had no content identity, so the thread stays at its position.
  positional: "positional",
  // Its key names several cells this run, so it is pinned to none.
  ambiguous: "ambiguous",
  // Its sheet or its cell is gone in this run.
  unplaced: "unplaced",
} as const;

export type CellCommentPlacementStatus =
  (typeof CELL_COMMENT_PLACEMENT)[keyof typeof CELL_COMMENT_PLACEMENT];

export interface ICellCommentUser {
  id: string;
  full_name: string;
}

export interface ICellComment {
  id: string;
  // Null once the author withdrew it.
  body: string | null;
  deleted: boolean;
  author: ICellCommentUser;
  mine: boolean;
  created_at: string;
}

export interface ICellCommentThread {
  id: string;
  sheet_name: string;
  placement: {
    status: CellCommentPlacementStatus;
    sheet_id: string | null;
    // 1-based sheet coordinates, like IAiSpreadsheetCell.
    row: number | null;
    col: number | null;
    cell_id: string | null;
  };
  context: { value?: string; column_header?: string; row_label?: string };
  resolved_at: string | null;
  resolved_by: ICellCommentUser | null;
  created_by: ICellCommentUser;
  created_at: string;
  updated_at: string;
  comments: ICellComment[];
}

export interface ICellCommentThreadsResponse {
  threads: ICellCommentThread[];
}

export interface ICellCommentThreadResponse {
  thread: ICellCommentThread;
}

// Where a new comment goes: the saved (1-based) coordinate of the cell.
export interface ICellCommentTarget {
  sheetId: string;
  row: number;
  col: number;
}
